import {Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {DossierService} from "../../../../../services";
import {DictType, SvedIOUInfoType} from "../../../../../models/dossier";
import {AlertPanelService, ITableEditorItem, ITableItem} from "@amlCore/components";
import {DictionaryService} from "@amlCore/services";
import {Unsubscribable} from "rxjs";
import {DossierBaseModel} from "../../dossierBaseModel";
import {FormGroup} from "@angular/forms";
import {DossierBaseSubComponent} from "../dossierBaseSub.component";
import {ErrorFLKItemType} from "@amlCore/models";
import {SostavIODossierComponent} from "./sostavIO";
import {ClientTypeEnum} from "@amlCore/enums";

@Component({
  selector: 'app-iou-info-dossier',
  styleUrls: ['../../dossier.css'],
  templateUrl: './iouInfoDossier.component.html'
})
export class IouInfoDossierComponent extends DossierBaseSubComponent implements OnInit, OnDestroy, ITableItem {

  titlePanel = 'Сведения об органе управления';
  showTitle = true;
  isPostShow = false;
  isTableItem = false;
  organUprValueChanges: Unsubscribable;
  typeValueChanges: Unsubscribable;
  vidKolOUValueChanges: Unsubscribable;
  postValueChanges: Unsubscribable;
  clientTypeChange: number;
  showPart: boolean = false;

  @ViewChild('sostavIO') sostavIO: SostavIODossierComponent;

  constructor(protected dossierService: DossierService, protected dictSrv: DictionaryService,
              protected dossierBaseModel: DossierBaseModel,
              protected alertPanelService: AlertPanelService) {
    super(dossierService, dictSrv, alertPanelService);
  }

  /**
   * Описание формы
   */
  getFormDescription(data?: any): FormGroup {
    return this.dossierBaseModel.getSvedIUO(data);
  }

  /**
   * Инициализация FormGroup
   */
  initForm(data?: any): void  {
    if (!this.isTableItem) {
      this.formGroupApp = this.getFormDescription(data);
    }
  }

  ngOnInit(): void  {
    this.loadRemoteData(['supremegoverningbody', 'executivegoverningbody', 'collegialexecutivebody', 'post']);
    this.initOrganUpr(this.f('organUpr').value);
    this.organUprValueChanges = this.f('organUpr').valueChanges.subscribe(val => {
      this.initOrganUpr(val);
    });
    this.initType(this.f('type').value);
    this.typeValueChanges = this.f('type').valueChanges.subscribe(val => {
      this.initType(val);
    });
    this.vidKolOUValueChanges = this.f('vidKolOU').valueChanges.subscribe(val => {
      this.initVidKolOU(val);
    });
    this.postValueChanges = this.f('post').valueChanges.subscribe(val => {
      this.initPost(val);
    });

    this.addUnsubscribable(this.organUprValueChanges);
    this.addUnsubscribable(this.typeValueChanges);
    this.addUnsubscribable(this.vidKolOUValueChanges);
    this.focusObject = this.generateFocusObject(new SvedIOUInfoType());
    this.dossierService.clientTypeEmit.subscribe((data) => {
      this.clientTypeChange = data;
    });
  }


  setSubmitted(value: boolean): void  {
    this.submitted = value;
  }


  getTitle(): string {
    return this.titlePanel;
  }

  /**
   * Инициализируем компонент как элемент формы просмотра таблицы
   * @param param.form - форма для связи
   * @param param.params - дополнительные параметры
   */
  initTableItem(param: ITableEditorItem): FormGroup {
    this.initForm(param.model);
    this.isTableItem = true;
    if (param.model) {
      this.formGroupApp.patchValue(param.model);
    }
    this.showTitle = false;
    if (param.params && param.params.typePage) {
      this.typePage = param.params.typePage;
    } else {
      console.log('Необходимо указать typePage у компонента');
    }
    this.isReadOnly = param.isReadOnly;
    if (this.isReadOnly){
      this.formGroupApp.disable();
    }
    return this.formGroupApp;
  }

  initOrganUpr(val?: DictType): void {
    if (!this.formGroupApp.disabled) {
      if (val) {
        const code = val.code;
        this.setDisabled('organUprOther', code != "99" )
        this.showPart = ['1', '2'].includes(code)
        this.setDisabled('part', !this.showPart);
      }
    }
  }

  setDisabled(fieldName: string, disable: boolean){
    const field = this.f(fieldName);
    disable ? field.disable({onlySelf: true})
      : field.enable({onlySelf: true});
    field.updateValueAndValidity({onlySelf: false});
  }

  initType(val): void {
    if (!this.formGroupApp.disabled) {
      if (val) {
        const isType2 = val?.code == "2";
        this.setDisabled('vidKolOU', !isType2);
        this.setDisabled('otherOU', !isType2 || this.f('vidKolOU')?.value?.code != "99");
        this.setDisabled('sostavIO', !isType2);
      }
    }
  }

  initVidKolOU(val): void {
    if (!this.formGroupApp.disabled) {
      if (val) {
        const code = val.code;
        if (code) {
          this.setDisabled('otherOU',  this.f('vidKolOU').disabled || code != "99");
        }
      }
    }
  }

  initClientType(clientType: ClientTypeEnum): void {
    this.isPostShow = ClientTypeEnum.INDIVIDUAL_PERSON === clientType;
    this.setDisabled('post', !this.isPostShow);
    this.initPost(this.f('post').value);
  }

  initPost(val: DictType): void {
    if (!this.formGroupApp.disabled) {
      this.setDisabled('otherPost', !this.isPostShow || !(val?.code == "99"));
    }
  }

  openSostavIO(event: ErrorFLKItemType) {
    if (event) {
      this.sostavIO.openWindow(this.dossierService.errorFLKTable);
    }
  }

  ngOnDestroy(): void {
    this.unsubscribable();
  }
}
